import React from 'react'

const Arrival = () => {
  return (
    <div>Arrival</div>
  )
}

export default Arrival